import request from '@/utils/request';
import {
  endpoints,
  updateUserGroupEndpoint,
  usersUserGroupsEndpoint,
  userGroupMembersEndpoint,
  userGroupsEndpoint,
  userGroupEndpoint,
} from '@/constants/urls';

const entityUserGroupsDestroy = (entity, entityCode, userGroupCode) => request({
  url: userGroupsEndpoint(entity, entityCode, userGroupCode),
  method: 'DELETE',
});

const entityUserGroupsCreate = (entity, entityCode, userGroupCode, data) => request({
  url: userGroupsEndpoint(entity, entityCode, userGroupCode),
  method: 'POST',
  data,
});

const entityUserGroupsUpdate = (entity, entityCode, { code: userGroupCode, permissions }) => request({
  url: userGroupsEndpoint(entity, entityCode, userGroupCode),
  data: permissions,
  method: 'PUT',
});

const userGroups = (filter, page, pageSize, orderBy, bpmn) => (
  request({
    url: endpoints.USER_GROUPS,
    params: {
      filter, page, pageSize, orderBy, bpmn,
    },
    method: 'GET',
  })
);

const userGroup = (entityCode) => request({
  url: userGroupEndpoint(entityCode),
  method: 'GET',
});

const updateUserGroup = (entityCode, { name, description, bpmn }) => request({
  url: userGroupEndpoint(entityCode),
  method: 'PATCH',
  data: { name, description, bpmn },
});

const usersUserGroups = (user, page, pageSize) => (
  request({
    url: usersUserGroupsEndpoint(user.uuid, page, pageSize),
    params: { page, pageSize },
    method: 'GET',
  })
);

const userGroupUsers = (userGroupCode, page, pageSize) => (
  request({
    url: userGroupMembersEndpoint(userGroupCode),
    params: { page, pageSize },
    method: 'GET',
  })
);

const addUserToGroup = (userGroupCode, userUUID) => (
  request({
    url: userGroupMembersEndpoint(userGroupCode, userUUID),
    method: 'POST',
  })
);

const removeUserFromGroup = (userGroupCode, userUUID) => (
  request({
    url: userGroupMembersEndpoint(userGroupCode, userUUID),
    method: 'DELETE',
  })
);

const createGroup = (group) => entityUserGroupsCreate(undefined, undefined, undefined, group);

const assignUsersToGroup = (userGroupCode, users) => request({
  url: updateUserGroupEndpoint(userGroupCode),
  method: 'PATCH',
  data: users,
});

const destroyGroup = ({ code }) => request({
  url: userGroupEndpoint(code),
  method: 'DELETE',
});

const UserGroupsService = {
  addUserToGroup,
  assignUsersToGroup,
  createGroup,
  destroyGroup,
  entityUserGroupsCreate,
  entityUserGroupsDestroy,
  entityUserGroupsUpdate,
  removeUserFromGroup,
  updateUserGroup,
  userGroup,
  userGroups,
  userGroupUsers,
  usersUserGroups,
};

export default UserGroupsService;
